import { styled } from "@mui/system"
import { Box, Card, Typography } from "@mui/material"

export const ModalCard = styled(Card)({
  display: "flex",
  width: "560px",
  padding: "24px 32px",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "24px",
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
})

export const ModalHeader = styled(Typography)({
  alignSelf: "stretch",
  fontSize: "24px",
  fontWeight: 400,
  lineHeight: "32px",
})

export const ModalContent = styled(Typography)({
  alignSelf: "stretch",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: "0.5px",
})

export const ButtonWrapper = styled(Box)({
  display: "flex",
  padding: "8px 16px",
  alignItems: "flex-start",
  gap: "11px",
  alignSelf: "stretch",
})

export const Spacer = styled(Box)({
  height: "24px",
  flex: "1 0 0",
})
